import { render, staticRenderFns } from "./addAntManage.vue?vue&type=template&id=67b1d5f0&scoped=true"
import script from "./addAntManage.vue?vue&type=script&lang=ts"
export * from "./addAntManage.vue?vue&type=script&lang=ts"
import style0 from "./addAntManage.vue?vue&type=style&index=0&id=67b1d5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b1d5f0",
  null
  
)

export default component.exports